<template>
    <div class="view power-hours">
        <app-sub-navbar parent="performance"></app-sub-navbar>
        <div class="container-fluid">
            <app-graph-filter class="text-center" @filterLoaded="initialLoad" @filterChanged="filterChangedMethod" @switchChange="switchChanged" ref="graphFilter"></app-graph-filter>
            <app-power-hours-table ref="table" @rowClicked="tableClicked"></app-power-hours-table>
            <div class="row row-eq-height" v-show="$store.state.graphFilter.powerhoursSelectedStore !== null">
                <div class="col-12 mt-50" v-if="$store.state.graphFilter.powerhoursSelectedStore !== null">
                    <el-card style="height: 65px;">
                        <h4 class="title fl">Details for store {{$store.state.general.stores.find(x => x.store_id === $store.state.graphFilter.powerhoursSelectedStore).store_name}}</h4>
                    </el-card>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-12 mt-50">
                    <app-power-hours-stats-table ref="statsTable"></app-power-hours-stats-table>
                </div>
                <div class="col-lg-6 col-12 mt-50" v-for="day in getRelevantDays" :key=day>
                    <el-card class="box-card" style="height: 100%;" :day=day :ref=day>
                        <div slot="header" class="text-left">
                            <h4 class="inline">{{day | formatVariableName}}</h4>
                        </div>
                        <app-power-hours-day-graph :day=day :ref=day></app-power-hours-day-graph>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubNavbar from '../../components/SubNavbar'
import PowerHoursDayGraph from '../../components/performance/PowerHoursDayGraph'
import GraphFilter from '../../components/performance/PowerHoursFilter'
import PowerHoursTable from '../../components/performance/PowerHoursTable'
import PowerHoursStatsTable from '../../components/performance/PowerHoursStatsTable'
export default {
    data () {
        return {
            days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
        }
    },
    components: {
        appSubNavbar: SubNavbar,
        appPowerHoursDayGraph: PowerHoursDayGraph,
        appGraphFilter: GraphFilter,
        appPowerHoursTable: PowerHoursTable,
        appPowerHoursStatsTable: PowerHoursStatsTable
    },
    computed: {
        getRelevantDays () {
            if (this.$store.state.performance.powerHoursGraphData.length !== 0) {
                let relevantData = this.$store.state.performance.powerHoursGraphData.data.map(x => x.weekday)
                let days = []
                for (let item of this.days) {
                    if (relevantData.indexOf(item) !== -1 && days.indexOf(item) === -1) {
                        days.push(item)
                    }
                }
                return days
            } else {
                return []
            }
        }
    },
    methods: {
        filterChangedMethod (value) {
            this.$refs['table'].getTableData(value['stores'])
        },
        tableClicked (value) {
            this.$refs['statsTable'].getTableData(this.$store.state.graphFilter.powerhoursSelectedStore)
            // this.$refs['monday'].drawChart(this.$store.state.graphFilter.powerhoursSelectedStore)
            this.$store.dispatch('performance/getPowerHoursGraphData', [this.$store.state.graphFilter.powerhoursSelectedStore]).then(response => {
                for (let day of this.getRelevantDays) {
                    this.$refs[day][0].drawChart()
                }
            })
        },
        switchChanged () {
            this.$refs['table'].sortRankData()
        },
        initialLoad (value) {
            this.$refs['table'].getTableData(value['stores'])
            this.$refs['statsTable'].getTableData(this.$store.state.graphFilter.powerhoursSelectedStore)
            this.$store.dispatch('performance/getPowerHoursGraphData', [this.$store.state.graphFilter.powerhoursSelectedStore]).then(response => {
                for (let day of this.getRelevantDays) {
                    this.$refs[day][0].drawChart()
                }
            })
        }
    },
    created () {
    }
}
</script>
